import GET_SHARDS_ANSWER_DATA from "@/graphql/dynamic_form/shards_answer_data.gql";

class FormAnswerDataFetcher {
  constructor({ apolloClient }) {
    this.apolloClient = apolloClient;
  }

  async fetchAnswerDataForDynamicForm({
    dynamicForm,
    answerableId,
    answerableType,
  }) {
    const dynamicFormShardIds = this.formShardIds(dynamicForm);

    const result = await this.apolloClient.query({
      query: GET_SHARDS_ANSWER_DATA,
      fetchPolicy: "no-cache",
      variables: {
        dynamicFormShardIds: dynamicFormShardIds,
        answerableId: answerableId,
        answerableType: answerableType,
      },
    });

    return result.data.dynamicFormShardsAnswerData;
  }

  formShardIds(dynamicForm) {
    return dynamicForm.links.map((link) => this.linkShardIds(link)).flat();
  }

  linkShardIds(link) {
    const nextShardIds = link.shard.links
      .map((nextLink) => this.linkShardIds(nextLink))
      .flat();

    return [link.shard.id, ...nextShardIds];
  }
}

export { FormAnswerDataFetcher };
